import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "container bg-light h-100 border sh-2 justify-content-center align-content-center",
    style: { "border-color": "#d1d9e0 !important", "box-shadow": "0 -1px 13px 2px rgb(41 41 41 / 16%)" }
};
const _hoisted_2 = { class: "row h-100" };
const _hoisted_3 = { class: "col-7 col-md-5 col-lg-8 fw-bold my-auto text-truncate" };
const _hoisted_4 = { class: "col-5 col-md-7 col-lg-4 sh-2 my-auto text-end" };
const _hoisted_5 = { class: "btn-group d-none d-md-inline-flex" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("button", { class: "btn btn-primary btn-sm" }, "Bestellen", -1);
const _hoisted_7 = { class: "btn-group d-none d-md-inline-flex" };
const _hoisted_8 = {
    key: 1,
    class: "btn-group d-none d-md-inline-flex"
};
const _hoisted_9 = { class: "btn btn-primary btn-sm" };
const _hoisted_10 = { class: "btn-group" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("button", {
    class: "btn btn-sm btn-outline-primary dropdown-toggle",
    type: "button",
    id: "cmdCartActions",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
}, " Aktionen ", -1);
const _hoisted_12 = {
    class: "dropdown-menu dropdown-menu-end",
    "aria-labelledby": "cmdCartActions"
};
const _hoisted_13 = /*#__PURE__*/ _createTextVNode(" Bestellen ");
const _hoisted_14 = { key: 1 };
const _hoisted_15 = { key: 2 };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("hr", { class: "dropdown-divider" }, null, -1);
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("hr", { class: "dropdown-divider" })
], -1);
const _hoisted_19 = { key: 4 };
const _hoisted_20 = { key: 5 };
const _hoisted_21 = { class: "container position-relative h-100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_portal = _resolveComponent("portal");
    const _component_g_breadcrumb = _resolveComponent("g-breadcrumb");
    const _component_router_link = _resolveComponent("router-link");
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_DxExport = _resolveComponent("DxExport");
    const _component_DxScrolling = _resolveComponent("DxScrolling");
    const _component_DxFilterRow = _resolveComponent("DxFilterRow");
    const _component_DxColumn = _resolveComponent("DxColumn");
    const _component_DxFormat = _resolveComponent("DxFormat");
    const _component_DxColumnChooser = _resolveComponent("DxColumnChooser");
    const _component_DxColumnFixing = _resolveComponent("DxColumnFixing");
    const _component_DxGroupPanel = _resolveComponent("DxGroupPanel");
    const _component_DxSearchPanel = _resolveComponent("DxSearchPanel");
    const _component_DxGrouping = _resolveComponent("DxGrouping");
    const _component_DxPaging = _resolveComponent("DxPaging");
    const _component_dx_data_grid = _resolveComponent("dx-data-grid");
    const _component_g_content_page = _resolveComponent("g-content-page");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_portal, {
            to: "command-bar",
            order: 900
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.OnCreate()), ["prevent"]))
                    }, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Create')), 1)
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.OnRefresh($event)), ["prevent"]))
                    }, _toDisplayString(_ctx.$tc('client.Common.Refresh')), 1)
                ])
            ]),
            _: 1
        }),
        _createVNode(_component_g_content_page, null, {
            title: _withCtx(() => [
                _createVNode(_component_g_breadcrumb, { "show-home": true })
            ]),
            content: _withCtx(() => [
                _createElementVNode("div", {
                    style: { "position": "fixed", "z-index": "1050", "right": "10px", "left": "10px", "bottom": "10px" },
                    class: _normalizeClass([_ctx.isVisible ? 'm-fadeIn' : 'm-fadeOut'])
                }, [
                    (_ctx.currentRow && _ctx.currentRow.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currentRow[0].cartName), 1),
                                _createElementVNode("div", _hoisted_4, [
                                    (_ctx.currentRow[0].cartType === 'L')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createVNode(_component_router_link, {
                                                    to: '/order-lists/' + _ctx.currentRow[0].cartID
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_6
                                                    ]),
                                                    _: 1
                                                }, 8, ["to"])
                                            ]),
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("button", {
                                                    class: "btn btn-success btn-sm",
                                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.OnOrderListSend(_ctx.currentRow[0])), ["stop", "prevent"]))
                                                }, "Absenden")
                                            ])
                                        ], 64))
                                        : (_ctx.currentRow[0].lineCount > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                _createVNode(_component_router_link, {
                                                    to: '/checkout/' + _ctx.currentRow[0].cartID
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Command.Checkout')), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["to"])
                                            ]))
                                            : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_10, [
                                        _hoisted_11,
                                        _createElementVNode("ul", _hoisted_12, [
                                            (_ctx.currentRow[0].cartType === 'L')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("li", null, [
                                                        _createVNode(_component_router_link, {
                                                            to: '/order-lists/' + _ctx.currentRow[0].cartID,
                                                            class: "dropdown-item"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_13
                                                            ]),
                                                            _: 1
                                                        }, 8, ["to"])
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.dOnOrderListSend(_ctx.currentRow[0])), ["stop", "prevent"])),
                                                            class: "dropdown-item"
                                                        }, "Absenden")
                                                    ])
                                                ], 64))
                                                : (_ctx.currentRow[0].lineCount > 0)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                                                        _createVNode(_component_router_link, {
                                                            to: '/checkout/' + _ctx.currentRow[0].cartID,
                                                            class: "dropdown-item"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$tc('client.Commerce.Carts.Command.Checkout')), 1)
                                                            ]),
                                                            _: 1
                                                        }, 8, ["to"])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                            (_ctx.currentRow[0].cartType === 'L' || _ctx.currentRow[0].lineCount > 0)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_15, _hoisted_17))
                                                : _createCommentVNode("", true),
                                            (_ctx.currentRow[0].cartType === 'L')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.OnOrderListToCart(_ctx.currentRow[0])), ["stop", "prevent"])),
                                                            class: "dropdown-item"
                                                        }, "In Warenkorb umwandeln")
                                                    ]),
                                                    _hoisted_18
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            (_ctx.currentRow[0].cartState !== 'A')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                                    _createElementVNode("a", {
                                                        href: "#",
                                                        onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.renameCart(_ctx.currentRow[0])), ["stop", "prevent"])),
                                                        class: "dropdown-item"
                                                    }, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Command.Rename')), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_ctx.currentRow[0].cartState !== 'A')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                                    _createElementVNode("a", {
                                                        href: "#",
                                                        onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.deleteCart(_ctx.currentRow[0])), ["stop", "prevent"])),
                                                        class: "dropdown-item"
                                                    }, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Command.Delete')), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn btn-outline-danger btn-sm",
                                        onClick: _cache[7] || (_cache[7] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_ctx.hideToolbar && _ctx.hideToolbar(...args)), ["stop", "prevent"]))
                                    }, [
                                        _createVNode(_component_g_icon, {
                                            src: "/assets/icons/x.svg",
                                            style: { "margin-bottom": "1px", "margin-top": "-1px" }
                                        })
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_21, [
                    (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_dx_data_grid, {
                        "data-source": _ctx.carts,
                        "allow-column-reordering": true,
                        "row-alternation-enabled": false,
                        "allow-column-resizing": true,
                        selection: { mode: 'single' },
                        "show-borders": true,
                        "hover-state-enabled": true,
                        "column-min-width": 50,
                        "column-auto-width": false,
                        onSelectionChanged: _ctx.onSelectionChanged,
                        ref: "grdMain"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_DxExport, { enabled: true }),
                            _createVNode(_component_DxScrolling, { mode: "infinite" }),
                            _createVNode(_component_DxFilterRow, {
                                visible: true,
                                "apply-filter": "auto"
                            }),
                            _createVNode(_component_DxColumn, {
                                "data-field": "cartNumber",
                                width: "100",
                                alignment: "center",
                                caption: _ctx.$tc(`client.Commerce.${this.cartType === 'L' ? 'OrderLists' : 'Carts'}.Title`),
                                "css-class": "align-middle"
                            }, null, 8, ["caption"]),
                            _createVNode(_component_DxColumn, {
                                "data-field": "cartName",
                                caption: _ctx.$tc('client.Commerce.Carts.Caption'),
                                "css-class": "align-middle",
                                "min-width": 300
                            }, null, 8, ["caption"]),
                            _createVNode(_component_DxColumn, {
                                "data-field": "deliveryZipCode",
                                caption: "Plz",
                                width: "100",
                                alignment: "center",
                                "css-class": "align-middle"
                            }),
                            _createVNode(_component_DxColumn, {
                                "data-field": "deliveryCity",
                                caption: "Ort",
                                width: "200",
                                "css-class": "align-middle"
                            }),
                            _createVNode(_component_DxColumn, {
                                "data-field": "lineCount",
                                caption: _ctx.$tc('client.Commerce.Carts.Lines'),
                                alignment: "center",
                                width: "100",
                                "css-class": "align-middle"
                            }, null, 8, ["caption"]),
                            _createVNode(_component_DxColumn, {
                                "data-field": "totalNetAmount",
                                caption: _ctx.$tc('client.Commerce.Carts.Amount'),
                                alignment: "center",
                                width: "100",
                                "css-class": "align-middle"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_DxFormat, {
                                        type: "fixedPoint",
                                        precision: 2
                                    })
                                ]),
                                _: 1
                            }, 8, ["caption"]),
                            _createVNode(_component_DxColumn, {
                                "data-field": "currency",
                                caption: "Wkz",
                                alignment: "center",
                                width: "50",
                                "css-class": "align-middle"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_DxFormat, {
                                        type: "fixedPoint",
                                        precision: 2
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_DxColumnChooser, { enabled: false }),
                            _createVNode(_component_DxColumnFixing, { enabled: true }),
                            _createVNode(_component_DxGroupPanel, { visible: false }),
                            _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                "highlight-case-sensitive": true,
                                width: 250
                            }),
                            _createVNode(_component_DxGrouping, { "auto-expand-all": false }),
                            _createVNode(_component_DxPaging, { "page-size": 20 })
                        ]),
                        _: 1
                    }, 8, ["data-source", "onSelectionChanged"])
                ])
            ]),
            _: 1
        })
    ], 64));
}
